module.exports = __webpack_public_path__ + "img/21.2b5db8b6.jpeg";